export default (set, get, promoProductsToAdd) => {
  set(() => ({
    allPromoProducts: { ...get().allPromoProducts, ...promoProductsToAdd }
  }),
  false,
  { type: 'groupedPromo/addPromoProducts', data: promoProductsToAdd });
};
